import React, { useEffect, useState } from 'react';
import { BASE_API } from '../../api/Globals';                                   
import { helpHttp } from '../../helpers/helpHttp';
import { useParams } from "react-router";
import { useFormNewPassword } from '../../hooks/useFormNewPassword';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';

const initialForm = {
    contraseña: "",
    rcontraseña: ""
}

const validationsFrom = (form) => {
    let errors = {};

    if(!form.contraseña.trim()) {
        errors.contraseña = "El Campo (Nueva Contraseña) es requerido";
    } 

    if(!form.rcontraseña.trim()) {
        errors.rcontraseña = "El Campo (Repetir Contraseña) es requerido";
    } 

    if(form.contraseña.trim() !== form.rcontraseña.trim()) {
        errors.igual_contraseña = "Los campos (Nueva Contraseña y Repetir Contraseña) deben ser iguales.";
    }
    
    return errors;
}

const NewPassword = () => { 
    
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    
    let {q} = useParams();

    let url = `${BASE_API}auth/verification/password/${q}`;

    const {
        form, 
        errors,
        loadup,
        response,
        handleChange,
        handleBlur,
        handleLogin} = useFormNewPassword(initialForm, validationsFrom, q);

    
    useEffect(() => {
        setLoading(true);
        if(q) { 
            helpHttp().get(url).then(res => {
                if(!res.err) {
                    if(res.response === 'on') {
                        setError(false);
                    } else {
                        setError(true);
                    }
                } else {
                    setError(true);
                }
                setLoading(false);
            });
        } else {
            // ir a home
        }

    }, [url]);
    

    return (
        <>
            {loading && <Loader /> }
            {!error ? 
                <div className='surface-ground px-4 py-8 md:px-6 lg:px-8 flex align-items-center justify-content-center'>
                    <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
                        <div className="text-center mb-5">
                            <img src="assets/layout/images/LOGOTIPO SEC PNG.png" alt="hyper" height="120" className="mb-3" />
                            <div className="text-900 text-3xl font-medium mb-3">NUEVA CONTRASEÑA</div>
                            <span className="text-600 font-medium line-height-3">
                                Ingresar tu correo electrónico para recibir un código de verificación y recuperar tu contraseña.
                            </span>
                        </div>
                    
                        <form onSubmit={handleLogin}>
                            <label htmlFor="contraseña" className="block text-900 font-medium mb-2">Nueva Contraseña:</label>
                            {errors.contraseña && <small className="p-error">{errors.contraseña}</small>}
                            <InputText id="contraseña" name="contraseña" autoComplete="off" type="password" className={`w-full mb-3 ${errors.contraseña && 'p-invalid'}`} value={form.contraseña} onChange={handleChange} onBlur={handleBlur} autoFocus />

                            <label htmlFor="rcontraseña" className="block text-900 font-medium mb-2">Repetir Contraseña:</label>
                            {errors.rcontraseña && <><small className="p-error">{errors.rcontraseña}</small><br /></>}
                            {errors.igual_contraseña && <small className="p-error">{errors.igual_contraseña}</small>}
                            <InputText id="rcontraseña" name="rcontraseña" type="password" className={`w-full mb-3 ${errors.rcontraseña && 'p-invalid'}`} value={form.rcontraseña} onChange={handleChange} onBlur={handleBlur} />

                            {loadup && <Loader />}
                            {response && <MessageDetail color="error" mensaje={response} />}
                            <Button type="submit" disabled={loadup} label="Aceptar" icon="pi pi-user" className="w-full p-button-rounded" />
                        </form>
                    </div>
                </div>
            : 
                <MessageDetail mensaje="Ha expirado el tiempo para realizar este proceso." color='warn' />
            }
            
        </>
    );
}

export default NewPassword;